import React, { useState } from 'react'
import Modal from 'react-modal'
import Button from '../../components/Button'

const Hats = ({ hats, isLoggedUser }) => {
    const [state, setState] = useState({
        open: false,
        hat: null
    })

    const { open, hat } = state

    return (
        <div className='mb-8'>
            <h2 className='full-width'>Guarda-chapéus</h2>
            <article className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 justify-center items-center'>
                {!hats.length ?
                    <div className='col-span-3'>
                        {isLoggedUser ?
                            <>
                                <h4 className='pb-2'>Ainda não tem quaisquer chapéus!</h4>
                                <p>Para encontrar novos chapéus experimente novas narrativas em diferentes locais e tente continuar a visitar e desfrutar do jogo regularmente!</p>
                            </>
                            :
                            <p>Este utilizador não tem qualquer tipo de chapeús no seu guarda-chapéus!</p>
                        }
                    </div>
                    :
                    hats.map((item, index) =>
                        <Button
                            key={index}
                            onClick={() => setState({ open: !open, hat: item })}
                            className="p-6 mr-0 overflow-hidden flex flex-col flex-wrap justify-center image-button usable h-full"
                        >
                            <img className='mx-auto pb-2' alt={item.name} title={item.name} src={require(`../../assets/img/hats/${item.img}.png`)} />
                            <h3 className='pb-2'>{item.name}</h3>
                        </Button>
                    )}
                {hat &&
                    <Modal
                        isOpen={open}
                        contentLabel="Modal das Configurações"
                        className='modal'
                        ariaHideApp={false}
                        closeTimeoutMS={300}
                        shouldCloseOnOverlayClick={true}
                        onAfterClose={() => setState({ ...state, hat: null })}
                        onRequestClose={() => setTimeout(() => {
                            setState({ ...state, open: !open })
                        }, 300)}
                    >
                        <div className='modal-guts'>
                            <div className='flex flex-wrap justify-between items-center'>
                                <h2>{hat?.name}</h2>
                            </div>

                            <div className='grid grid-cols-1 lg:grid-cols-2'>
                                <img
                                    className='object-contain h-48 w-full'
                                    alt={hat?.name}
                                    title={hat?.name}
                                    src={require(`../../assets/img/hats/${hat?.img}.png`)}
                                />
                                <div>
                                    <p className='pb-2'><b>Descrição:</b> {hat?.description}</p>
                                    <p><b>Método de desbloqueio:</b> {hat?.trigger}</p>
                                </div>
                            </div>
                            <div className='pt-5 flex justify-end '>
                                <Button
                                    className='mr-0'
                                    onClick={() => setTimeout(() => {
                                        setState({ ...state, open: !open })
                                    }, 300)}
                                >
                                    Fechar
                            </Button>
                            </div>
                        </div>
                    </Modal>
                }
            </article>
        </div>

    )
}

export default Hats
